import React from 'react'
import { Field, formValueSelector, reduxForm } from 'redux-form'
import { Button, Form, FormGroup } from 'reactstrap'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import FormItem from '../../../common/forms/FormItem'
import DatePicker from '../../../common/forms/input/DatePicker'
import { tzNormalizeDate } from '../../../../utils/date'
import FormFooter from '../../../common/forms/FormFooter'
import Select from '../../../common/forms/select/Select'
import { ITINERARY_DIRECTION } from '../../../../config/constants'
import LocationSelect from '../../../common/forms/select/LocationSelect'
import { exportDriverForSchedulingFile } from '../../../../actions/traffic/DriverForScheduling'
import { INT_DATE_FORMAT } from '../../../../config/locale'
import ServiceTypeSelect from '../../../common/forms/select/ServiceTypeSelect'

const selector = formValueSelector('DriverForSchedulingSearchForm')

const DriverForSchedulingSearchForm = ({ handleSubmit, loading, dispatchExportDriverForSchedulingFile,
  directionValue, homeBaseLocationValue,
  fromDateStringValue,
  toDateStringValue,
  serviceTypesValue,
  showNorteChicoValue
}) => {

  const handleExportToExcel = () => {
    const formValues = {
      itineraryDirection: directionValue ? directionValue.value : null,
      homeBaseLocationId: homeBaseLocationValue ? homeBaseLocationValue.value : null,
      fromDateString: tzNormalizeDate({ date: fromDateStringValue, format: INT_DATE_FORMAT }),
      toDateString: tzNormalizeDate({ date: toDateStringValue, format: INT_DATE_FORMAT }),
      showNorteChico: showNorteChicoValue,
    }

    if (serviceTypesValue) {
      formValues.serviceTypes = serviceTypesValue.map(st => st.value);
    }

    dispatchExportDriverForSchedulingFile(formValues)
  }

  return (
    <Form onSubmit={handleSubmit}>
      <FormGroup row>
        <FormItem label='Dirección'>
          <Field
            name="direction"
            component={Select}
            options={Object.values(ITINERARY_DIRECTION)}
            placeholder="Seleccione una dirección"
            isClearable
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Base">
          <Field
            name="homeBaseLocation"
            component={LocationSelect}
            placeholder="Bases"
            forHomeBase
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label='Fecha Inicial' required>
          <Field
            name="fromDateString"
            component={DatePicker}
            placeholder="Seleccione una fecha"
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label='Fecha Final' required>
          <Field
            name="toDateString"
            component={DatePicker}
            placeholder="Seleccione una fecha"
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label='Tipo de servicio' required>
          <Field
            name="serviceTypes"
            component={ServiceTypeSelect}
            placeholder="Seleccione un tipo de servicio"
            isMulti
            showAll
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Norte Chico">
          <Field
            name="showNorteChico"
            component="input"
            type="checkbox"
          />
        </FormItem>
      </FormGroup>
      <FormFooter
        saveButtonText="Buscar "
        saveButtonIcon="fa fa-search"
        saveButtonDisabled={loading}
      >
        <Button className="mr-2" color="secondary" type="button" onClick={handleExportToExcel} disabled={loading}>
          <i className="fa fa-file-excel-o mr-1" />
          Exportar a Excel
        </Button>
      </FormFooter>
    </Form>
  )
}

DriverForSchedulingSearchForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  dispatchExportDriverForSchedulingFile: PropTypes.func.isRequired,
  directionValue: PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  }).isRequired,
  fromDateStringValue: PropTypes.instanceOf(Date),
  toDateStringValue: PropTypes.instanceOf(Date),
  homeBaseLocationValue: PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  }).isRequired,
  serviceTypesValue: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string,
        label: PropTypes.string,
      }))]),
  showNorteChicoValue: PropTypes.bool.isRequired
}

DriverForSchedulingSearchForm.defaultProps = {
  loading: false,
  fromDateStringValue: null,
  toDateStringValue: null,
  serviceTypesValue: null,
}

const form = reduxForm({
  form: 'DriverForSchedulingSearchForm',
  initialValues: {
    origin: null,
    destination: null,
    fromDateString: tzNormalizeDate(),
    toDateString: tzNormalizeDate(),
    direction: null,
    homeBaseLocation: null,
    showNorteChico: false,
  }
})(DriverForSchedulingSearchForm)


const mapStateToProps = (state) => ({
  directionValue: selector(state, 'direction'),
  homeBaseLocationValue: selector(state, 'homeBaseLocation'),
  fromDateStringValue: selector(state, 'fromDateString'),
  toDateStringValue: selector(state, 'toDateString'),
  serviceTypesValue: selector(state, 'serviceTypes'),
  showNorteChicoValue: selector(state, 'showNorteChico'),
})

const mapDispatchToProps = {
  dispatchExportDriverForSchedulingFile: exportDriverForSchedulingFile
}

export default connect(mapStateToProps, mapDispatchToProps)(form)